import React from 'react';
import { Popover as HLPopover } from '@headlessui/react';
import usePopoverContext from './usePopoverContext';
import { BaseButtonProps } from '@teetsh/app/src/components/Buttons/BaseButtonProps';
import { buttonRootStyle } from '@teetsh/app/src/components/Buttons/Button';
import { ButtonContent } from '@teetsh/app/src/components/Buttons/ButtonContent';
import clsx from 'clsx';

interface Props {
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function PopoverButton(props: Props & BaseButtonProps) {
  const { refs, fill } = usePopoverContext();
  const {
    loading,
    minimal,
    outlined,
    small,
    className,
    active,
    alignText,
    disabled,
    extralarge,
    intent,
    onClick,
    onMouseDown,
    large,
  } = props;
  // si tu mets div à la place de Fragment tu as safari qui te style le wrapper ...
  return (
    <HLPopover.Button
      onClick={e => {
        const target = e.target as HTMLElement;
        if (onClick && target.dataset?.triggerType !== 'programmatic') {
          onClick(e);
        }
      }}
      onMouseDown={onMouseDown}
      css={[
        buttonRootStyle({
          active,
          alignText,
          disabled,
          extralarge,
          fill,
          hasChildren: !!props.children,
          large,
          loading,
          minimal,
          outlined,
          intent,
          small,
        }),
      ]}
      ref={refs.setReference}
      className={clsx('tsh-button', className)}
      aria-label={props['aria-label']}
      data-testid={props['data-testid']}
    >
      <ButtonContent {...props} />
    </HLPopover.Button>
  );
}
